window.yesNo = (params) => {
  if (params.value == "1") {
    return "Evet";
  }
  return "Hayır";
};
